import { KeyboardCapslockOutlined } from "@mui/icons-material";
import Keycloak from "keycloak-js";
import AuthServices from "./AuthServices";
import {setServerBaseUrl} from "./ConfigServices";

/**
 Initialise l'instance Keycloak et appelle la fonction de rappel fournie si l'authentification est réussie.
 * @param renderingApplication
 */
const keycloak = new Keycloak("/keycloak.json");

const initKeycloak = (renderingApplication) => {
    console.log('init');
    keycloak
        .init({
            onLoad: "login-required",
            promiseType: "native"
        })
        .then(async function (authenticated) {
            if (authenticated) {
                localStorage.setItem("_expiredTime", 0);
                console.log("Authenticated");
                setServerBaseUrl(keycloak.tokenParsed?.backendurl);
                console.log(keycloak);

                await AuthServices.getAuthorization();
                console.log("Autauthorized");
                renderingApplication();
            } else {
                getLogin();
            }
           updatingToken();
        })
        .catch(function (error) {
            console.error("Authenticated Failed");
            console.error(error);
        });
};

const updatingToken =()=>{
    // console.log('update');
    return setTimeout(() => {
        keycloak
            .updateToken(60)
            .then(function(refreshed) {
                if (refreshed === true) {
                    // console.info("Token refreshed", refreshed);
                } else {
                    // console.info("Token still valid");
                }
            })
            .catch(function () {
                console.error("Failed to refresh token");
                getLogout();
            });
        updatingToken();
    }, 30000);
}

const getLogin = keycloak.login;

const getLogout = () => {
    // console.log("logout from keycloak");
    keycloak.logout();
} 

const getToken = () => keycloak.token;

const isLoggedIn = () => !!keycloak.token;

const updateToken = (successCallback) => {
    // console.log("update token");
    return keycloak.updateToken(5).then(successCallback).catch(getLogin);
}
    

const getUsername = () => keycloak.tokenParsed?.preferred_username;
const getEmail = () => keycloak.tokenParsed?.email;
const getLastName = () => keycloak.tokenParsed?.family_name;
const getFirstName = () => keycloak.tokenParsed?.given_name;
const getFullName = () => keycloak.tokenParsed?.name;

const hasRole = (roles) => roles.some((role) => keycloak.hasRealmRole(role));

const UserService = {
    initKeycloak,
    getLogin,
    getLogout,
    isLoggedIn,
    getToken,
    updateToken,
    getUsername,
    hasRole,
    getEmail,
    getFirstName,
    getLastName,
    getFullName,
};

export default UserService;


